import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 22 23',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M9.429,4.807V6.6a.566.566,0,0,1-.589.539H6.875A.566.566,0,0,1,6.286,6.6v-1.8a.566.566,0,0,1,.589-.539H8.839A.566.566,0,0,1,9.429,4.807Zm5.7-.539H13.161a.566.566,0,0,0-.589.539V6.6a.566.566,0,0,0,.589.539h1.964a.566.566,0,0,0,.589-.539v-1.8A.566.566,0,0,0,15.125,4.268ZM8.839,8.58H6.875a.566.566,0,0,0-.589.539v1.8a.566.566,0,0,0,.589.539H8.839a.566.566,0,0,0,.589-.539v-1.8A.566.566,0,0,0,8.839,8.58Zm6.286,0H13.161a.566.566,0,0,0-.589.539v1.8a.566.566,0,0,0,.589.539h1.964a.566.566,0,0,0,.589-.539v-1.8A.566.566,0,0,0,15.125,8.58ZM8.839,12.893H6.875a.566.566,0,0,0-.589.539v1.8a.566.566,0,0,0,.589.539H8.839a.566.566,0,0,0,.589-.539v-1.8A.566.566,0,0,0,8.839,12.893Zm6.286,0H13.161a.566.566,0,0,0-.589.539v1.8a.566.566,0,0,0,.589.539h1.964a.566.566,0,0,0,.589-.539v-1.8A.566.566,0,0,0,15.125,12.893ZM22,22.1V23H0v-.9a.566.566,0,0,1,.589-.539h.982V1.078A1.132,1.132,0,0,1,2.75,0h16.5a1.132,1.132,0,0,1,1.179,1.078V21.563h.982A.566.566,0,0,1,22,22.1Zm-3.143-.539V1.438H3.143V21.563H9.429V17.744a.566.566,0,0,1,.589-.539h1.964a.566.566,0,0,1,.589.539v3.818Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
